import React from 'react'
import styles from './styles.module.scss'

interface WhyChooseUsProps {
    onScrollToForm: () => void
}

export const WhyChooseUs: React.FC<WhyChooseUsProps> = ({ onScrollToForm }) => {
    return (
        <section className={styles.whyChooseSection}>
            <div className={styles.container}>
                <div className={styles.twoColumnLayout}>
                    <div className={styles.leftColumn}>
                        <h2>Why Choose Sentinel Legal?</h2>
                        <p className={styles.leadText}>
                            With years of experience in consumer finance law, we've helped thousands of clients recover
                            compensation for irresponsible lending.
                        </p>
                        <div className={styles.featureList}>
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>🏆</div>
                                <div>
                                    <h4>Proven Track Record</h4>
                                    <p>Successfully recovered millions in compensation for our clients</p>
                                </div>
                            </div>
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>⚡</div>
                                <div>
                                    <h4>Fast & Efficient</h4>
                                    <p>Quick case assessment and streamlined claims process</p>
                                </div>
                            </div>
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>🛡️</div>
                                <div>
                                    <h4>No Win, No Fee</h4>
                                    <p>You don't pay unless we successfully recover compensation</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.rightColumn}>
                        <div className={styles.statsCard}>
                            <h3>Our Success Statistics</h3>
                            <div className={styles.statItem}>
                                <span className={styles.statNumber}>95%</span>
                                <span className={styles.statLabel}>Success Rate</span>
                            </div>
                            <div className={styles.statItem}>
                                <span className={styles.statNumber}>£15M+</span>
                                <span className={styles.statLabel}>Recovered for Clients</span>
                            </div>
                            <div className={styles.statItem}>
                                <span className={styles.statNumber}>5,000+</span>
                                <span className={styles.statLabel}>Happy Clients</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.ctaCenter}>
                    <button className={styles.ctaButton} onClick={onScrollToForm}>
                        Check Your Eligibility Now
                    </button>
                </div>
            </div>
        </section>
    )
}
